import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[nimbusGridDetailsTemplate]',
  standalone: false,
})
export class NimbusGridDetailsTemplateDirective {
  @Input()
  public showIf: (dataItem: any) => boolean;

  public constructor(public templateRef: TemplateRef<any>) {}
}
